import { Component, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Supplier } from 'app/entities';
import { Subject } from 'rxjs';
import { openCatalogFormDialog } from '../catalog-form-dialog/catalog-form-dialog.component';

// Botão de cadastro/edição: abre o formulário em diálogo (antes era um mat-menu).
@Component({
  selector: 'app-card-drop-down-supplier-create',
  templateUrl: './card-drop-down-supplier-create.component.html',
})
export class CardDropDownSupplierCreateComponent {

  @Input() appearance: string = 'standard';
  @Input() supplier: Supplier | null = null;
  @Output() onCreated = new Subject<Supplier>();
  @Output() onUpdated = new Subject<Supplier>();
  @Input() responsiveBtn = false;
  // Só ícone (ex.: criar dentro de um select): recebe aria-label e tooltip
  @Input() iconOnly = false;
  readonly label = 'Novo fornecedor';

  constructor(private _dialog: MatDialog) { }

  onClick(event: Event) {
    // Item de menu (Editar): deixa o menu da linha fechar. Nos demais casos (ex.: dentro
    // da busca de um select) o clique não pode chegar à opção do select.
    if (this.appearance !== 'mat-menu-item') {
      event.stopPropagation();
    }
    this.open();
  }

  open() {
    openCatalogFormDialog<Supplier>(this._dialog, { kind: 'supplier', entity: this.supplier })
      .subscribe((result) => {
        if (result?.action === 'created') {
          this.onCreated.next(result.value);
        } else if (result?.action === 'updated') {
          this.onUpdated.next(result.value);
        }
      });
  }

}
